<template>
    <section class="fleet-setup-vendors-setup mb-2">
        <div class="team-added-card">
            <div class="team-added-header">
                <div class="complete-icon"><icon name="faCheck" type="solid"></icon></div>
                <div>
                    <h2 class="my-0 td-h4">Import Vendors</h2>
                </div>
            </div>
            <p class="mt-1 mb-0">Upload a file of your internal vendors.  Our team will match them to our vendor network and flag each of them as your preferred vendors, ensuring that your vendors show first.</p>
            <p class="td-text-mice mt-1 mb-0">Please allow 1-2 weeks for us to process the file.  You can also send us a file anytime at info@truckdown.com.  Supported file types: .xlsx, .csv, .xls, .ods.</p>
            <div :class="['td-dropzone', { dragging: isDragging }]"
                 @dragover="onDragOver"
                 @dragleave="onDragLeave"
                 @drop="onDrop">
                <form enctype="multipart/form-data" method="post">
                    <input type="file" name="file" @change="onFileChange" ref="fileInput" accept=".xlsx,.csv,.xls,.ods" />
                </form>

                <icon name="faFileArrowUp" type="solid" class="upload-icon"></icon>
                <p class="mb-1">Drag & drop file here or <strong class="td-text-primary" @click="triggerFileSelect">click to upload</strong>.</p>
                <ul>
                    <li v-if="fileStatus">
                        <span v-if="uploadedFile">{{uploadedFile.name}}</span>
                        <div v-if="fileStatus === 'pending'" class="loading-bar mx-1">
                            <div class="bar"></div>
                        </div>

                        <span v-if="fileStatus === 'success'" class="td-text-success td-badge icon-left mx-1"> <icon name="faCheck" type="solid" aria-hidden="true"></icon> Uploaded</span>
                        <span v-if="fileStatus === 'error'" class="td-text-danger td-text-danger td-badge icon-left mx-1"> <icon name="faXmark" type="solid" aria-hidden="true"></icon> Failed</span>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>

<script>
import script from './VendorsSetup';
    export default script;</script>

<style lang="less">
    @import "./VendorsSetup.less";
</style>